module.exports = __webpack_public_path__ + "static/img/2015-B.f4e111f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/events/2015-B.png
// module id = g6JI
// module chunks = 1